import React from "react";
import insta1 from "../../src/Images/insta1.webp";
import insta2 from "../../src/Images/insta2.jpg";
import insta3 from "../../src/Images/insta3.jpg";
import insta4 from "../../src/Images/insta4.jpg";
import insta5 from "../../src/Images/insta5.jpg";

const InstaShop = () => {
  return (
    <div className="overflow-hidden relative bg-white">
      <div className="mt-10 flex flex-col items-center w-[100vw]">
        
        {/* ✅ SEO-friendly Heading */}
        <h6 className="text-xl sm:text-3xl text-center font-bold">
          Clariss Instashop
        </h6>
        <p className="text-xl text-center mt-4 text-accent font-bold">
          Follow Us on Instagram for Beauty Inspiration
        </p>

        {/* ✅ Instagram Feed Section */}
        <div className="grid grid-cols-2 sm:flex sm:flex-row justify-center items-center mt-10 sm:mx-0">
          
          {/* Instagram Post 1 */}
          <div className="overflow-hidden">
            <a
              href="https://www.instagram.com/clarissbangladesh/"
              target="_blank"
              rel="noopener noreferrer"
              aria-label="View Clariss Bangladesh Instagram Post 1"
            >
              <img
                className="w-[400px] ease-in-out duration-200 hover:scale-125"
                src={insta1}
                alt="Clariss Bangladesh Instagram Post – Skincare essentials"
                title="Clariss Bangladesh Skincare Post"
                loading="lazy"
              />
            </a>
          </div>

          {/* Instagram Post 2 */}
          <div className="overflow-hidden fa-rotate-90">
            <a
              href="https://www.instagram.com/clarissbangladesh/"
              target="_blank"
              rel="noopener noreferrer"
              aria-label="View Clariss Bangladesh Instagram Post 2"
            >
              <img
                className="w-[400px] ease-in-out duration-200 hover:scale-125"
                src={insta2}
                alt="Clariss Bangladesh Instagram Post – Haircare and beauty products"
                title="Clariss Bangladesh Haircare Post"
                loading="lazy"
              />
            </a>
          </div>

          {/* Instagram Post 3 */}
          <div className="overflow-hidden">
            <a
              href="https://www.instagram.com/clarissbangladesh/"
              target="_blank"
              rel="noopener noreferrer"
              aria-label="View Clariss Bangladesh Instagram Post 3"
            >
              <img
                className="w-[400px] ease-in-out duration-200 hover:scale-125"
                src={insta3}
                alt="Clariss Bangladesh Instagram Post – Natural fragrance collection"
                title="Clariss Bangladesh Fragrance Post"
                loading="lazy"
              />
            </a>
          </div>

          {/* Instagram Post 4 */}
          <div className="overflow-hidden">
            <a
              href="https://www.instagram.com/clarissbangladesh/"
              target="_blank"
              rel="noopener noreferrer"
              aria-label="View Clariss Bangladesh Instagram Post 4"
            >
              <img
                className="w-[400px] ease-in-out duration-200 hover:scale-125"
                src={insta4}
                alt="Clariss Bangladesh Instagram Post – Body care and self-care products"
                title="Clariss Bangladesh Body Care Post"
                loading="lazy"
              />
            </a>
          </div>

          {/* Instagram Post 5 */}
          <div className="overflow-hidden">
            <a
              href="https://www.instagram.com/clarissbangladesh/"
              target="_blank"
              rel="noopener noreferrer"
              aria-label="View Clariss Bangladesh Instagram Post 5"
            >
              <img
                className="w-[400px] ease-in-out duration-200 hover:scale-125 hidden sm:block"
                src={insta5}
                alt="Clariss Bangladesh Instagram Post – Premium beauty collection"
                title="Clariss Bangladesh Beauty Post"
                loading="lazy"
              />
            </a>
          </div>
        </div>

        {/* ✅ CTA for Instagram */}
        {/* <p className="text-center mt-6 font-bold">
          <a
            href="https://www.instagram.com/clarissbangladesh/"
            target="_blank"
            rel="noopener noreferrer"
            className="text-accent hover:underline"
          >
            👉 Follow @ClarissBangladesh on Instagram for exclusive updates!
          </a>
        </p> */}
      </div>
    </div>
  );
};

export default InstaShop;
